<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a href="" class="navbar-item">Jacob P. Dahl</a>

            <a
            v-on:click="burgerClick"
            v-bind:class="{ 'is-active': isActive }"
            role="button"
            class="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="nav-menu">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>


        <div 
        v-on:click="itemClick"
        v-bind:class="{ 'is-active': isActive }"
        class="navbar-menu" 
        id="nav-menu">
            <div class="navbar-end">
                <router-link class="navbar-item" to="/">Home</router-link>

                <div class="navbar-item has-dropdown is-hoverable">
                    <router-link class="navbar-link" to="/projects">Projects</router-link>

                    <div class="navbar-dropdown">
                        <router-link class="navbar-item" to="/projects/f5">f5</router-link>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: "Navbar",
    data() {
        return {
            isActive: false,
        };
    },
    methods: {
        burgerClick() {
            this.isActive = !this.isActive;
        },
        itemClick() {
            this.isActive = false;
        }
    },
};
</script>
